import React, { useState, useCallback } from "react";
import {
    SimpleForm,
    Edit,
    TextInput,
    BooleanInput,
    SaveButton,
    DeleteWithConfirmButton,
    Toolbar,
    Notification,
    useNotify,
    NumberInput,
    ArrayInput
} from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { ThemeProvider } from "@material-ui/styles";
import customTheme from "../../customTheme";
import { validateRequired, valueBetween } from "../../utils/Validations";
import WithProps from "../Custom/WithProps";
import CustomAdminSelect from "./CustomAdminSelect";
import VideoPreview from "./VideoPreview";
import { CustomArrayIterator } from "./create-bestseller";

const useStyles = makeStyles(() => ({
    root: {
        width: "90%",
        margin: "auto",
    },
    toolbar: {
        justifyContent: "space-between",
    },
    grouping: {
        border: "1px solid lightgray",
        borderRadius: "3px",
        margin: "1% auto",
    },
    warnLabel: {
        fontSize: "10px",
        color: "red",
        display: "block",
    },
    displayFlex: {
        display: "flex",
    },
    equalWidth: {
        maxWidth: "33%",
    },
    heading: {
        fontWeight: "bold",
        marginTop: "10px",
        borderBottom: "3px solid #a6a5a5ff",
        paddingBottom: "5px",
    },
}));

const EditToolbar = (props) => {
    const classes = useStyles();
    return (
        <Toolbar {...props} className={classes.toolbar}>
            <SaveButton disabled={props.pristine} />
            <DeleteWithConfirmButton />
        </Toolbar>
    );
};

const EditBestSeller = (props) => {
    const classes = useStyles();
    
    const [checked, setChecked] = useState();
    const [kaysChecked, setKaysChecked] = useState();

    const handleChange = useCallback(
        (newChecked) => setChecked(newChecked),
        []
    );

    const handleKaysChange = useCallback(
        (newChecked) => setKaysChecked(newChecked),
        []
    );

    const notify = useNotify();
    const onFailure = (error) => {
        notify(
            error.response.data.message
                ? error.response.data.message
                : "Something went wrong",
            { type: "warning" }
        );
    };

    return (
        <ThemeProvider theme={customTheme}>
            <Edit mutationMode="pessimistic" onFailure={onFailure} {...props}>
                <WithProps>
                    {({ record, ...props }) => (
                        <SimpleForm
                            record={record}
                            {...props}
                            redirect="list"
                            toolbar={<EditToolbar />}
                        >
                            <Grid
                                container
                                spacing={2}
                                className={classes.root}
                                justify="space-between"
                            >
                                <Grid
                                    item
                                    container
                                    xs={12}
                                    className={classes.displayFlex}
                                    justify="space-between"
                                    alignItems="center"
                                >
                                    <Grid item xs={6}>
                                        <TextInput
                                            source="magic_number"
                                            label="Magic Number"
                                            validate={validateRequired}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <NumberInput
                                            source="discount_percentage"
                                            label="Discount Percentage"
                                            validate={[
                                                validateRequired,
                                                valueBetween(0, 100),
                                            ]}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <BooleanInput
                                            label={
                                                (typeof checked ===
                                                    "undefined" &&
                                                    record.active) ||
                                                checked
                                                    ? "Active"
                                                    : "Inactive"
                                            }
                                            source="active"
                                            initialValue={true}
                                            onChange={handleChange}
                                            checked={checked}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <CustomAdminSelect
                                            label="Video URL"
                                            source="video_url"
                                            resource="getBestsellerVideoList"
                                            validate={validateRequired}
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <BooleanInput
                                            label="Hide Quarter Sizes"
                                            source="hide_quarter_sizes"
                                            initialValue={false}
                                        />
                                    </Grid>
                                </Grid>
                                <VideoPreview />
                            </Grid>
                            <Grid
                                container
                                spacing={2}
                                className={classes.root}
                                alignItems="center"
                                justify="space-between"
                            >
                                <Grid
                                    item
                                    container
                                    xs={12}
                                    className={classes.heading}
                                >
                                    Kay's Configuration
                                </Grid>
                                <Grid item xs={3}>
                                    <NumberInput
                                        source="kays_discount_percentage"
                                        label="Kay's Discount Percentage"
                                        validate={[
                                            validateRequired,
                                            valueBetween(0, 100),
                                        ]}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <ArrayInput source="magic_numbers_for_kays_images">
                                        <CustomArrayIterator/>
                                    </ArrayInput>
                                </Grid>
                                <Grid item xs={3}>
                                    <BooleanInput
                                        label={
                                            (typeof kaysChecked ===
                                                "undefined" &&
                                                record.active_for_kays) ||
                                            kaysChecked
                                                ? "Active For Kays"
                                                : "Inactive For Kays"
                                        }
                                        source="active_for_kays"
                                        initialValue={true}
                                        onChange={handleKaysChange}
                                        checked={kaysChecked}
                                    />
                                </Grid>
                            </Grid>
                        </SimpleForm>
                    )}
                </WithProps>
            </Edit>
            <Notification />
        </ThemeProvider>
    );
};

export default EditBestSeller;
